/**
 * Cyber-Minimal TerminalLog Component
 * 
 * @param {Object} props
 * @param {string} props.title - Terminal header
 * @param {string[]} props.logs - Initial logs
 * @param {boolean} props.autoScroll - Whether to auto-scroll
 */
export function createTerminalLog({ title = 'EVENT_LOG', logs = [], autoScroll = true }) {
  const container = document.createElement('div');
  container.className = 'cm-terminal';
  
  const header = document.createElement('div');
  header.className = 'cm-terminal__header';
  header.textContent = title;
  
  const body = document.createElement('div');
  body.className = 'cm-terminal__body';
  
  const logList = document.createElement('ul');
  logList.className = 'cm-terminal__list';
  
  const addLog = (text) => {
    const li = document.createElement('li');
    li.className = 'cm-terminal__item';
    li.innerHTML = `<span class="cm-terminal__prompt">></span> ${text}`;
    logList.appendChild(li);
    
    if (autoScroll) {
      body.scrollTop = body.scrollHeight;
    }
  };
  
  logs.forEach(addLog);
  
  body.appendChild(logList);
  container.appendChild(header);
  container.appendChild(body);
  
  // Expose the log method
  container.addLog = addLog;
  container.clearLogs = () => { logList.innerHTML = ''; };
  
  return container;
}
